import React from 'react'

import { AuthContextProvider } from './Auth'
import { SocketProvider } from './Socket'

type Props = {
    children: React.ReactNode
}

export const ContextProviders: React.FC<Props> = ({ children }) => {
    return (
        <SocketProvider>
            <AuthContextProvider>{children}</AuthContextProvider>
        </SocketProvider>
    )
}
